export const VALIDATION = 'VALIDATION'

export const getValidationErrorMessage = (error) => {
  if (!error || error.type !== VALIDATION) return ''
  return error.messages.join(' ')
}
